import type { TicketMessage } from '@/types/ticket'
import { formatTime } from '@/lib/dates'

// A centred pill in the secondary-button treatment: assignment and status
// events are context for the conversation around them, so they read as one
// quiet object between messages rather than as a third participant. Time only,
// like the message rows either side — the day divider above carries the date.
// Internal events (a requester or company change) take the internal note's
// amber, so staff never mistake one for something the customer was shown.
export function SystemMessageRow({ message }: { message: TicketMessage }) {
  const tone = message.isInternal
    ? 'border border-etn-warning-text/25 bg-etn-warning-subtle'
    : 'bg-etn-control-subtle'
  return (
    <div className="my-3.5 text-center">
      <span
        className={`inline-flex items-center gap-2 rounded-etn-pill px-3 py-1 text-etn-micro text-etn-text-cell ${tone}`}
        data-testid="system-message"
        data-internal={message.isInternal ? 'true' : undefined}
      >
        {message.isInternal && <span className="font-semibold text-etn-warning-text">Internal</span>}
        <span>{message.body}</span>
        <span>{formatTime(message.createdAt)}</span>
      </span>
    </div>
  )
}
